import React from "react"
import "./CertificateNotFound.css"

const CertificateNotFound = () => (
  <div className="certificate-not-found-container">
    <div className="certificate-not-found-box">
      <h2 className="certificate-not-found-title">Certificate Not Found</h2>
      <p className="certificate-not-found-message">
        Sorry, we couldn't find a certificate matching this link.<br />
        Please contact support if you believe this is an error.
      </p>
    </div>
  </div>
)

export default CertificateNotFound
